<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader";
import api from "@/axios";
import CustomStore from 'devextreme/data/custom_store';
import DropZone from "@/components/widgets/dropZoneTexto";
import DropZonePlanilha from "@/components/widgets/dropZonePlanilha.vue";
import Swal from "sweetalert2";

import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations, DxHeaderFilter, DxSelection
} from 'devextreme-vue/data-grid';
import DxToolbar, {DxItem} from "devextreme-vue/toolbar";
import DxButton from "devextreme-vue/button";
import moment from "moment/moment";
import {ref} from "vue";
import {getBaseUrl} from "@/helpers/baseUrl";



export default {

  components: {
    DxSelection,
    DropZone, DropZonePlanilha,
    DxItem, DxButton, DxToolbar, Layout, PageHeader, Loader,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxPager,  DxFilterRow, DxRemoteOperations, DxHeaderFilter
  },

  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };
    return { dropzoneFile, drop};
  },

  data() {
    return {
      title: "Contas a Receber Detalhado",
      items: [
        {
          text: "Financeiro",
          href: "/financeiros/creceberdetalhado"
        },
        {
          text: "Contas a Receber Detalhado",
          active: true
        }
      ],
      selectedItems: 0,
      dataList: null,
      updating: false,
      showModalPeriodo: false,
      dtIniFiltro: null,
      dtFimFiltro: null,
      submittedPeriodo: false,
      totalizadores: [],
      parcSelecteds: [],
      idsparcSelectedsQuita: [],
      idsNaoHabilitadoQuita: [],
      idsparcSelectedsDeleta: [],
      idsNaoHabilitadoDeleta: [],
      vltQuitaLote: 0.00,
      dtEditaLote: moment().format('YYYY-MM-DD'),

      showModalFileExtrato: false,
      showModalImportacaoFinanceiro: false,
      submittedFileExtrato: false,

      showModalEditLote: false,
      currentTab: 'quitaLote', // Aba inicial
      tabs: [
        // { name: 'alteraLote', label: 'Altera Lote' },
        { name: 'quitaLote', label: 'Quita em Lote' },
        { name: 'deletaLote', label: 'Deleta em Lote' },
      ],
    };
  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted contasReceber-list_0')
    this.atualizaDataList()
  },

  methods: {
    confImportacaoFinanceiro(){
      console.log('confImportacaoFinanceiro')
      console.log(this.dropzoneFile)

      let arquivo = this.dropzoneFile;
      if(arquivo != null || arquivo != ""){
        /*
        * Verificando tamanho do arquivo e extensão
        * */
        // console.log('arquivo')
        // console.log(arquivo)
        let fileExtension = arquivo.name.split('.');
        console.log(`fileExtension: ${fileExtension[fileExtension.length - 1]}`)

        if(!['xlsx', 'xls'].includes(fileExtension[fileExtension.length - 1])) {
          Swal.fire({
            position: "center",
            icon: "warning",
            title: 'Selecione um arquivo válido!',
            showConfirmButton: false,
            timer: 3500
          });
        } else {
          if(arquivo.size > 1000000){
            Swal.fire({
              position: "center",
              icon: "warning",
              title: 'Arquivos com mais de 1MB devem ser tratados via suporte!',
              showConfirmButton: true,
            }).then(() => {
              //Limpando dropzone
              this.dropzoneFile = ""
            })
          }else{
            this.showModalImportacaoFinanceiro = false;
            this.updating = false;

            // Objeto form data
            let formData = new FormData();
            formData.append('filename', arquivo.name);
            formData.append('file', arquivo);

            api.post(`${getBaseUrl()}api/importfinanceiro`, formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then((res) => {
              console.log('then axios');
              console.log(res);

              Swal.fire({
                position: "top-end",
                icon: "success",
                title: res.data[0],
                showConfirmButton: false,
                timer: 3500
              });

            }).catch((err) => {

              console.log('erro axios');
              // console.log(err)
              // console.log(err.response)
              // console.log(err.response.data.errors)
              let erros = err.response.data.errors;
              console.log(erros);
              console.log(typeof erros);
              let listaErros = [];
              Object.keys(erros).forEach(key => {
                console.log(key, erros[key]);
                listaErros.push({
                  'titulo': key,
                  'mensagem': erros[key]
                });
              });
              this.errosValid = listaErros;
              this.updating = false;
            });
          }
        }
      } else {
        console.log('error: dropzonefile is empty!')

        Swal.fire({
          position: "center",
          icon: "warning",
          title: 'Selecione pelo menos um arquivo válido!',
          showConfirmButton: false,
          timer: 3500
        });
      }
    },

    importarHistorico(){
      this.showModalImportacaoFinanceiro = true
    },

    selectedFile(){
      console.log('selectedFile')
      this.dropzoneFile = document.querySelector(".dropzoneFile").files[0]
    },


    confExtrato(){
      console.log('confExtrato')
      this.showModalFileExtrato = true
      if (this.dropzoneFile.name){
        this.showModalFileExtrato = false
        this.updating = true

        let arquivo = document.querySelector(".dropzoneFile").files[0]
        console.log(arquivo)
        let formData = new FormData()
        formData.append("iddata", this.idData)
        formData.append("descranexo", this.descranexo)
        formData.append("filename", arquivo.name)
        formData.append("file", arquivo)

        api.post(`${getBaseUrl()}api/extratofile`,formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.updating = false

          /*
            * Retornando dados response
            * */
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: res.data[0],
            showConfirmButton: false,
            timer: 3500
          }).then(() => {
            /*
            * Limpando dropzone
            * */
            this.dropzoneFile = null
          })

        }).catch((err) => {

          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
        })
      }
    },

    atualizarItensSelecionados(e) {
      this.selectedItems = e.selectedRowsData.length; // Atualiza selectedItems com o número de linhas selecionadas
    },

    selectTab(tab) {
      this.currentTab = tab;
    },

    abrirEditarLote(){

      console.log('getSelectedItems')
      // console.log(this.dataGrid.getSelectedRowsData())
      // this.idsparcSelecteds = this.dataGrid.getSelectedRowKeys()
      const selecteds = this.dataGrid.getSelectedRowsData()

      this.idsparcSelectedsDeleta = []
      this.idsparcSelectedsQuita = []
      this.idsNaoHabilitadoDeleta = []
      this.idsNaoHabilitadoQuita = []
      selecteds.forEach((value) => {

        if(value.finanparc_status === 'AB') {
          value.habilitadoDelete = true;

          if (value.finanparc_vencimento > this.dtEditaLote) {
            value.habilitadoQuita = true
            this.idsparcSelectedsQuita.push(value.finanparc_id)
          } else {
            value.habilitadoQuita = false
            this.idsNaoHabilitadoQuita.push(value.finanparc_id)
          }

          this.idsparcSelectedsDeleta.push(value.finanparc_id)

        } else {
          value.habilitadoDelete = false;
          value.habilitadoQuita = false;
          this.idsNaoHabilitadoDeleta.push(value.finanparc_id)
          this.idsNaoHabilitadoQuita.push(value.finanparc_id)
        }

      })

      this.parcSelecteds = selecteds

      this.showModalEditLote = true;

    },

    quitandoLote (idsparcSelectedsQuita){
      console.log('quitandoLote')
      // console.log(idsparcSelectedsQuita)

      if(!idsparcSelectedsQuita || idsparcSelectedsQuita.length <= 0){
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Nenhum documento habilitado foi relacionado",
          showConfirmButton: false,
          timer: 2500
        })
      }else {

        Swal.fire({
          position: "center",
          icon: "question",
          title: "Quitação de Registros",
          text: "Esta operação é irreversível, tem certeza que deseja continuar?",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,

        }).then(result => {
          if (result.value) {
            this.loadingParcelas = true
            api.post(`${getBaseUrl()}api/qitfinanparc`, {
                'iddata': idsparcSelectedsQuita,
            }).then((res) => {
              console.log('then axios quita em Lote')
              console.log(res.data)

              if (res.data[0] === 'sucesso') {
                Swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: res.data[1],
                  showConfirmButton: false,
                  timer: 1500
                })

              } else if (res.data[0] === 'erro') {
                Swal.fire({
                  position: "top-end",
                  icon: "error",
                  title: res.data[1],
                  showConfirmButton: false,
                  timer: 1500
                })
              }

              this.showModalEditLote = false
              this.loadingParcelas = false
              this.atualizaDataList()
            })
          }
        })
      }
    },


    deletandoLote (idsparcSelectedsDeleta){
      console.log('deletandoLote')
      // console.log(idsparcSelectedsDeleta)
      if(!idsparcSelectedsDeleta || idsparcSelectedsDeleta.length <= 0){
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Nenhum documento habilitado foi relacionado",
          showConfirmButton: false,
          timer: 2500
        })
      }else {
        Swal.fire({
          position: "center",
          icon: "question",
          title: "Exclusão de Registros",
          text: "Esta operação é irreversível, tem certeza que deseja continuar?",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,

        }).then(result => {
          if (result.value) {
            this.loadingParcelas = true
            api.delete(`${getBaseUrl()}api/finanparc`, {
              params: {
                'iddata': idsparcSelectedsDeleta
              }
            }).then((res) => {
              console.log('then axios delete')
              console.log(res.data)

              if (res.data[0] === 'sucesso') {
                Swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: res.data[1],
                  showConfirmButton: false,
                  timer: 1500
                })

              } else if (res.data[0] === 'erro') {
                Swal.fire({
                  position: "top-end",
                  icon: "error",
                  title: res.data[1],
                  showConfirmButton: false,
                  timer: 1500
                })
              }

              this.showModalEditLote = false
              this.loadingParcelas = false
              this.atualizaDataList()

            })
          }
        })
      }
    },

    novaConta(){
      console.log('novaConta')
      this.$router.push(`/creceber/editar/0`)
    },

    nomeStatus(e) {
      switch (e.value) {
        case 'A':
          return 'Ativa (A)'
        case 'Q':
          return 'Quitado (Q)'
        case 'X':
          return 'Cancelado (X)'
      }

      return e.value
    },

    nomeStatusBaixa(baixa) {
      switch (baixa.value) {
        case 'EL':
          return 'Elaboração(EL)'
        case 'AB':
          return 'Em Aberto'
        case 'AG':
          return 'Agendado'
        case 'QT':
          return 'Quitado'
      }

      return baixa.value
    },

    confirmarPeriodo(){
      console.log('confirmarPeriodo')

      localStorage.setItem('filtros', JSON.stringify({
        'findi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'findf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))


      this.showModalPeriodo = false
      this.atualizaDataList()
    },


    atualizaDataList(){
      console.log('atualizaDataList_contaReceberDetalhado')


      const filtros = JSON.parse(localStorage.getItem("filtros"))
      console.log('filtros')
      console.log(filtros)

      if (!filtros) {
        console.log('cookie dataMov não existe, criando')
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'findi': perIniPadrao,
          'findf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['findi']
        this.dtFimFiltro = filtros['findf']
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro){
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      const di = this.dtIniFiltro
      const df = this.dtFimFiltro

      this.dataList = new CustomStore({
        key: "finanparc_id",
        load: function(loadOptions) {
          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }
          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
            'di': di,
            'df': df
          }
          return api.get(`${getBaseUrl()}api/creceberdetalhado`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data')
            console.log(response)

            this.totalizadores = response.data[2];

            return {
              data: response.data[0],
              totalCount: response.data[1],
            }
          })
        },
      })
    },

    carregouGrid(e){
      console.log('carregouGrid')
      const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')
      this.title = `(${e.component.totalCount()}) Contas a receber detalhado: ${dtIniFormated} - ${dtFimFormated}`

      this.totalizadores = this.dataList.totalizadores;
    },



    onRowDblClick(row) {
      console.log('onRowDblClick')

      let idData = row.data.finanparc_financ_id
      console.log(idData)
      const routeData = this.$router.resolve(`/creceber/editar/${idData}`)
      window.open(routeData.href, '_blank')
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "finanparc_status") {

          let dataAtual = new Date(Date.now())
          dataAtual.setDate(dataAtual.getDate() + 1)

          const vencimentoParc = Date.parse(e.data.financeiro_vencimento)
          const baixaParcStatus = e.data.finanparc_status

          let corStatus = 'rgba(78,59,0,0.5)'

          if(baixaParcStatus === 'AB' && (vencimentoParc < dataAtual)){
            corStatus = 'rgba(223,121,106,0.98)'
          } else {
            switch (baixaParcStatus) {
              case 'QT':
                corStatus = 'rgba(46,184,134,0.96)'
                break
              case 'AB':
                corStatus = 'rgba(248,178,58,0.82)'
                break
              case 'AG':
                corStatus = 'rgba(101,166,249,0.82)'
                break
              case 'VC':
                corStatus = 'rgba(223,121,106,0.98)'
                break
            }
          }

          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        }

        this.onCellVencimentoPrepared(e)
      }
    },

    onCellVencimentoPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "finanparc_vencimento") {
          // let dataAtual = new Date(Date.now())
          // dataAtual.setDate(dataAtual.getDate() + 1)
          // const vencimentoParc = Date.parse(e.data.finanparc_vencimento)
          const difvenc = e.data.finanparc_difvenc;

          let corCell = 'rgba(78,59,0,0.5)'

          if(difvenc < 0){
            corCell = 'rgba(223,121,106,0.98)'
          }else{
            if(e.data.finanparc_status !== "QT"){
              corCell = 'rgba(248,178,58,0.82)'
            } else {
              corCell = 'rgba(46,184,134,0.96)'
            }

          }

          e.cellElement.style.cssText = `color: white; background-color: ${corCell}`;

        }
      }
    },


    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    formatInteger(value) {
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

  },

};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true"/>

    <div>
      <div class="card-body border-top mb-3">
        <h5 class="text-truncate mb-4">Panorama geral do período Filtrado:</h5>
        <div class="text-center">
          <div class="row">
            <div class="col-sm-3">
              <div>
                <div class="font-size-24 text-primary mb-2">
                  <i class="bx bx-line-chart text-info"></i>
                </div>

                <p class="text-muted mb-2">Geral</p>
                <h5>{{ this.totalizadores.geral }}</h5>
              </div>
            </div>

            <div class="col-sm-3">
              <div class="mt-4 mt-sm-0">
                <div class="font-size-24 text-primary mb-2">
                  <i class="bx bx-check-double text-success"></i>
                </div>

                <p class="text-muted mb-2">Quitados</p>
                <h5>{{ this.totalizadores.quitado }}</h5>
              </div>
            </div>

            <div class="col-sm-3">
              <div class="mt-4 mt-sm-0">
                <div class="font-size-24 text-primary mb-2">
                  <i class="bx bxs-comment-detail text-warning"></i>
                </div>
                <p class="text-muted mb-2">Em Aberto</p>
                <h5>{{ this.totalizadores.emAberto }}</h5>
              </div>
            </div>

            <div class="col-sm-3">
              <div class="mt-4 mt-sm-0">
                <div class="font-size-24 text-primary mb-2">
                  <i class="bx bxs-comment-error text-danger"></i>
                </div>

                <p class="text-muted mb-2">Vencido</p>
                <h5>{{ this.totalizadores.vencido }}</h5>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div>

      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="add"
              hint="Criar Nova"
              :on-click="novaConta"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="edit"
              hint="Editar em Lote"
              text="Editar em Lote"
              :on-click="abrirEditarLote"/>
        </DxItem>

        <!--        <DxItem-->
        <!--            location="before"-->
        <!--            widget="dxButton">-->
        <!--          <DxButton-->
        <!--              icon="xlsxfile"-->
        <!--              hint="Importar histórico de contas a receber"-->
        <!--              :on-click="importarHistorico"/>-->
        <!--        </DxItem>-->

      </DxToolbar>

    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>

    <div class="mt-2">
      <p><strong>Itens Selecionados: {{ selectedItems }}</strong></p>
    </div>
    <div class="mt-2" v-if="!updating">


      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @content-ready="carregouGrid"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @exporting="onExporting"
          @selection-changed="atualizarItensSelecionados">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />

        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />
        <DxHeaderFilter :visible="true" />

        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strContasPagarList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping />


        <DxColumn
            sort-order="desc"
            data-field="finanparc_id"
            caption="ID Parcela"
            alignment="right"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>


        <DxColumn
            sort-order="desc"
            data-field="finanparc_financ_id"
            caption="ID Financeiro"
            alignment="right"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            sort-order="desc"
            data-field="finanparc_sequencial"
            caption="Sequência"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="finanparc_codigo"
            caption="Código"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="finanparc_numero"
            caption="Número"
            alignment="right"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="finanparc_status"
            caption="Status"
            alignment="center"
            data-type="text"
            :customize-text="nomeStatusBaixa"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true" />

        <DxColumn
            data-field="pessoa_nome"
            caption="Fornecedor"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="pessoa_cnpj"
            caption="CNPJ"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="financeiro_status"
            caption="Condição"
            alignment="center"
            data-type="text"
            :customize-text="nomeStatus"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true" />

        <DxColumn
            data-field="financeiro_categoria"
            caption="Categoria"
            alignment="center"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true" />

        <DxColumn
            data-field="finanparc_emissao"
            caption="Emissão"
            alignment="right"
            data-type="date"
            format="dd/MM/yyyy"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="finanparc_vencimento"
            caption="Vencimento"
            alignment="right"
            data-type="date"
            format="dd/MM/yyyy"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="finanparc_descdifvenc"
            caption="Desc. Vencimento"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true" />

        <DxColumn
            data-field="finanparc_difvenc"
            caption="Vencimento Dia"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true" />

        <DxColumn
            data-field="finanparc_dtbaixa"
            caption="Dt. Baixa"
            alignment="right"
            data-type="date"
            format="dd/MM/yyyy"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="finanparc_valor"
            caption="Valor(R$)"
            alignment="right"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="finanparc_juros"
            caption="Juros(R$)"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="finanparc_desconto"
            caption="Desconto(R$)"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="false"/>

        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[20, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>

      </DxDataGrid>
    </div>

    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span >Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span >Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

    <b-modal title="Arquivo Extrato Bancário Sicredi" v-model="showModalFileExtrato" centered hide-footer>
      <div>

        <div class="card-body">
          <h4 class="card-title">Selecionar novo arquivo</h4>
          <DropZone @change="selectedFile" />
          <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>
          <div v-if="submittedFileExtrato && !dropzoneFile.name">
            <span class="text-danger font-size-11">Favor selecionar o arquivo e tentar novamente.</span>
          </div>
        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalFileExtrato = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confExtrato">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal title="Importação histórico financeiro" v-model="showModalImportacaoFinanceiro" centered hide-footer>
      <div>

        <div class="card-body">
          <h4 class="card-title">Selecionar novo arquivo</h4>
          <DropZonePlanilha @change="selectedFile" />
          <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>
          <div v-if="submittedFileExtrato && !dropzoneFile.name">
            <span class="text-danger font-size-11">Favor selecionar o arquivo e tentar novamente.</span>
          </div>
        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalImportacaoFinanceiro = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confImportacaoFinanceiro">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal :title="`Editar Financeiro em Lote`" v-model="showModalEditLote" hide-footer>

      <div class="row">

        <ul class="nav nav-tabs">
          <li class="nav-item" v-for="tab in tabs" :key="tab.name">
            <a class="nav-link"
               :class="{ active: currentTab === tab.name }"
               href="javascript:void(0);"
               @click="selectTab(tab.name)">
              {{ tab.label }}
            </a>
          </li>
        </ul>

        <div v-if="currentTab === 'quitaLote'">

          <div class="card-body">

            <div class="row">

              <div class="col-12 mb-4">
                <span>
                  <strong class="text-warning">Warning!</strong> <br>
                  Esta função <strong class="text-warning">quita</strong> todos os registro financeiros <strong class="text-warning">"Em Aberto e não vencidos"</strong> que foram selecionados.
                </span>
              </div>

              <div class="col-6">
                <div class="mb-3">
                  <label for="numero">Número de documento</label>
                  <input
                      id="numero"
                      v-model="this.idsparcSelectedsQuita"
                      type="text"
                      disabled
                      class="form-control"
                      placeholder="Número de documento"/>
                </div>
              </div>

              <div class="col-6">
                <div class="mb-3">
                  <label for="recorrdtbaixa">Data de Quitação</label>
                  <input
                      id="recorrdtbaixa"
                      v-model="this.dtEditaLote"
                      type="date"
                      disabled
                      class="form-control"
                      placeholder="Data de Quitação"/>
                </div>
              </div>
            </div>

            <div class="col-12 mb-4">
              <hr>
              <span class="text-warning">
                <strong>Obs:</strong> Se documentos não habilitados foram relacionados, significa que os mesmos estão vencidos e não serão quitados neste movimento.
              </span>
              <div class="d-flex mt-3">
                  <label for="numero" class="col-5">Doc. não Habilitado:</label>
                  <input
                      id="numero"
                      v-model="this.idsNaoHabilitadoQuita"
                      type="text"
                      disabled
                      class="form-control"
                      placeholder="Número de documento"/>
              </div>
            </div>


            <div class="text-end mt-3">
              <b-button variant="light" @click="showModalEditLote = false">
                <i class="bx bx-block font-size-16 align-middle me-2"></i>
                Cancelar
              </b-button>
              <b-button variant="success" class="ms-2" @click="quitandoLote(idsparcSelectedsQuita)">
                <i class="bx bx-money font-size-16 align-middle me-2"></i>
                Quitar
              </b-button>
            </div>
          </div>
        </div>

        <div v-if="currentTab === 'deletaLote'">
          <div class="card-body">

            <div class="row">

              <div class="col-12 mb-4">
                <span>
                  <strong class="text-danger">Warning!</strong> <br>
                  Esta função <strong class="text-danger">deleta</strong> todos os registro financeiros <strong class="text-danger">"Em Aberto"</strong> que foram selecionados.
                </span>
              </div>

              <div class="col-6">
                <div class="mb-3">
                  <label for="numero">Número de documento</label>
                  <input
                      id="numero"
                      v-model="this.idsparcSelectedsDeleta"
                      type="text"
                      disabled
                      class="form-control"
                      placeholder="Número de documento"/>
                </div>
              </div>

              <div class="col-6">
                <div class="mb-3">
                  <label for="recorrdtbaixa">Data de Quitação</label>
                  <input
                      id="recorrdtbaixa"
                      v-model="this.dtEditaLote"
                      type="date"
                      disabled
                      class="form-control"
                      placeholder="Data de Quitação"/>
                </div>
              </div>
            </div>

            <div class="col-12 mb-4">
              <hr>
              <span class="text-danger">
                <strong>Obs:</strong> Se documentos não habilitados foram relacionados, significa que os mesmos estão quitados e não serão deletados neste movimento.
              </span>
              <div class="d-flex mt-3">
                <label for="numero" class="col-5">Doc. não Habilitado:</label>
                <input
                    id="numero"
                    v-model="this.idsNaoHabilitadoDeleta"
                    type="text"
                    disabled
                    class="form-control"
                    placeholder="Número de documento"/>
              </div>

            </div>

            <div class="text-end mt-3">
              <b-button variant="light" @click="showModalEditLote = false">
                <i class="bx bx-block font-size-16 align-middle me-2"></i>
                Cancelar
              </b-button>
              <b-button variant="danger" class="ms-2" @click="deletandoLote(idsparcSelectedsDeleta)">
                <i class="bx bx-trash font-size-16 align-middle me-2"></i>
                Deletar
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>



  </Layout>
</template>